import { Component, OnInit, Input, ViewChild, TemplateRef } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BsModalService, BsModalRef } from 'ngx-bootstrap';
import { ToasterService } from 'angular2-toaster';
import swal from 'sweetalert2';

import { AddEditHearinglossComponent } from './addEditHearingloss.component';

import { HearingLossModel } from '../../../model/index';
import { HearingLossService } from '../../../services/index';

@Component({
    selector: 'hearingloss-tab',
    templateUrl: './hearingloss.component.html',
})
export class HearinglossMasterComponent implements OnInit {
    @Input('tabTitle') title: string;
    @Input() active = false;
    @Input() isCloseable = false;
    @Input() dataContext;

    public mode: string;
    public list: any[] = [];
    public hearinglossdata: any[] = [];

    isLoadMask: Promise<any>;
    hearinglossData: HearingLossModel[];
    isLoading: boolean = false;

    constructor(private hearinglossService: HearingLossService, private modalService: BsModalService) { }

    loadingIndicator: boolean = true;
    reorderable: boolean = true;

    page = {
        limit: 25,
        count: 0,
        offset: 0,
        orderBy: 'name',
        orderDir: 'asc'
    };

    @ViewChild('snoTemplate') snoTemplate: TemplateRef<any>;
    @ViewChild('editDeleteTemplate') editDeleteTemplate: TemplateRef<any>;

    columns = [];
    scrollTimeout: any;
    suppressPaging: boolean = false;

    ngOnInit(): void {
        this.columns = [
            { name: 'SNo', prop: 'sno', width: 70, minWidth: 70, maxWidth: 70, cellClass: 'cell-center', sortable: false, cellTemplate: this.snoTemplate },
            { name: 'NAME', prop: 'name', width: 380, minWidth: 380, maxWidth: 380 },
            { name: 'Action', prop: 'sno', width: 100, minWidth: 100, maxWidth: 100, sortable: false, cellClass: 'cell-center', cellTemplate: this.editDeleteTemplate }
        ];

        this.pageCallback({ offset: 0 });
    }

    /**
    * Called whenever the user changes page
    */
    pageCallback(pageInfo: { count?: number, pageSize?: number, limit?: number, offset?: number }) {
        if (!this.suppressPaging) {
            this.page.offset = pageInfo.offset;
            this.getHearinglossList();
        }
    }

    /**
   * Called whenever the user changes the sort order
   */
    sortCallback(sortInfo: { sorts: { dir: string, prop: string }[], column: {}, prevValue: string, newValue: string }) {
        // there will always be one "sort" object if "sortType" is set to "single"
        this.page.orderDir = sortInfo.sorts[0].dir;
        this.page.orderBy = sortInfo.sorts[0].prop;
        this.getHearinglossList();
    }
    onScroll() {
        this.suppressPaging = true;
        if (this.scrollTimeout) {
            //celarTimeout(this.scrollTimeout);
        }
        this.scrollTimeout = setTimeout(() => {
            this.suppressPaging = false;
        }, 100)
    }
    onChangePageSize(limit) {
        this.page.limit = limit;
        this.getHearinglossList();
    }

    getHearinglossList(): void {
        let params = {
            start: `${this.page.offset}`,
            limit: `${this.page.limit}`,
            orderColumn: `${this.page.orderBy}`,
            orderDir: `${this.page.orderDir}`
        };
        let that = this;
        this.isLoadMask = this.hearinglossService
            .getHearinglossList(params)
            .then(function(res: any) {
                that.loadingIndicator = false;
                that.page.count = res.totCnt;
                that.hearinglossData = res.data;
            });
    }

    bsModalRef: BsModalRef;
    public onAddEditHearingloss(mode: string, row: any): void {
        let that = this;
        this.bsModalRef = this.modalService.show(AddEditHearinglossComponent, {
            keyboard: false,
            ignoreBackdropClick: true
        });
        row['mode'] = mode;

        this.bsModalRef.content.title = mode + ' Hearing Loss Details';
        //this.bsModalRef.content.mode = 'Add';
        //this.bsModalRef.content.hearinglossdata = {};
        this.bsModalRef.content.hearinglossdata = Object.assign({}, row);
        this.bsModalRef.content.hearingLossLoadEvent.subscribe(($e) => {
            that.getHearinglossList();
        });
    }

    // onEditHearingloss(row: any): void {
    //     this.bsModalRef = this.modalService.show(AddEditHearinglossComponent, {
    //         keyboard: false,
    //         ignoreBackdropClick: true
    //     });
    //     this.bsModalRef.content.hearinglossdata = Object.assign({}, row);
    //     this.bsModalRef.content.title = 'Edit PHONE TRACK Details';
    //     this.bsModalRef.content.mode = 'Edit';
    //     this.bsModalRef.content.hearinglossdata = row;
    // }

    onDeleteHearingloss(row: any): void {
        let that = this;
        swal({
            title: 'Are you sure to Delete?',
            text: 'You will not be able to Recover Testing Type: ' + row.name + ' Again!',
            showCancelButton: true,
            confirmButtonText: 'Yes, Delete!',
            cancelButtonText: 'No, Keep it'
        }).then(function() {
            that.isLoadMask = that.hearinglossService
                .deleteHearingloss(row.id)
                .then(function(res: any) {
                    if (res.success) {
                        that.getHearinglossList();
                        swal(
                            'Deleted',
                            res.message,
                            'success'
                        );
                    } else {
                        swal(
                            'ERROR',
                            res.message,
                            'error'
                        );
                    }

                });
        }, function(dismiss) {

        });
    }
}



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/components/master/hearingLoss/hearingloss.component.ts